var React = require('react');

function ArrowPlain (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .arrow-plain-inner {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"f9df67c7-c283-4890-bc15-1edca74c7809","data-name":"arrow-plain-inner","key":1},React.createElement("g",{"id":"a33b93c5-ad2c-45c5-afaf-66b8bac8d5e4","data-name":"Path 219"},React.createElement("polygon",{"className":"arrow-plain-inner","points":"41.27 9.22 32.05 18.43 30.28 16.67 36.48 10.47 0 10.47 0 7.97 36.48 7.97 30.28 1.77 32.05 0 41.27 9.22"})))]);
}

ArrowPlain.defaultProps = {"id":"f043a4a2-126c-43e9-b80d-5142a91f2068","data-name":"arrow-plain","viewBox":"0 0 41.26996 18.42999"};

module.exports = ArrowPlain;

ArrowPlain.default = ArrowPlain;
